import { FlatTreeControl } from '@angular/cdk/tree';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { MatTreeFlatDataSource, MatTreeFlattener } from '@angular/material/tree';
import { LoginStoreEffects } from '@app/root-store/login-store/effects';
import { DragDropService } from '@app/shared/services/drag-drop/drag-drop.service';
import { InboxSettingsService } from '@app/shared/services/settings/inbox-settings/inbox-settings.service';
import { environment } from '@env/environment';
import { fetchAuthSession } from 'aws-amplify/auth';
import { ToastrService } from 'ngx-toastr';
import { element } from 'protractor';
import { Observable, Subscription, fromEvent } from 'rxjs';
import { AutoUnsubscribe } from '@app/shared/decorators/auto-unsubscribe.decorator';
@AutoUnsubscribe()
@Component({
  selector: 'file-list-upload-v2-mobile',
  templateUrl: './file-list-upload-v2-mobile.component.html',
  styleUrls: ['./file-list-upload-v2-mobile.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FileListUploadV2MobileComponent implements OnInit, OnDestroy {
  @Output() moveNextPreviousEvent = new EventEmitter<any>();
  @Input() data;
  @Input() origin = 'onboarding';
  fileListDataTree = [];
  fileList = [];
  loginStateObject;
  screenWidth: number;
  resizeObservable$: Observable<Event>;
  progressdata = [];
  hasFile = false;
  completedCount = 0;
  loadOnce = true;
  isActiveDrag = false;
  isLoading = true;
  FileUploadedLimit = 30;
  FiletListDataList: Array<any> = [];
  subscription: Subscription = new Subscription();
  showLader;
  folderList = [];

  loadingItems = [{ id: 1 }, { id: 2 }, { id: 3 }];

  // Worker references for proper cleanup
  private activeWorkers: Map<string, Worker> = new Map();

  constructor(
    private dragDropService: DragDropService,
    private cd: ChangeDetectorRef,
    private _inboxService: InboxSettingsService,
    private toastr: ToastrService,
    private loginService: LoginStoreEffects
  ) {
    this.subscription.add(
      this.loginService.loginObject.subscribe((state) => {
        this.loginStateObject = { ...state.data };
        if (state.data.id) {
          this.loadOnce = false;
          this.getInboxData(state.data.id);
        }
      })
    );
  }
  ngOnDestroy(): void {
    this.subscription?.unsubscribe();

    // Terminate all active workers
    this.activeWorkers.forEach((worker, id) => {
      worker.terminate();
    });
    this.activeWorkers.clear();
  }

  refreshFile() {
    this.getInboxData(this.loginStateObject.id);
  }
  ngOnInit(): void {
    this.screenWidth = window.innerWidth;
    this.resizeObservable$ = fromEvent(window, 'resize');
    this.subscription.add(
      this.resizeObservable$.subscribe((evt) => {
        this.screenWidth = evt.target['innerWidth'];
      })
    );
  }

  // method to get inbox data
  getInboxData(userId: number) {
    this.subscription.add(
      this._inboxService.getInboxData(userId).subscribe(
        (result: any) => {
          // stop loading
          this.fileList = [];
          result?.data.forEach((element) => {
            if (this.origin == 'mobile') {
              if (element.origin == 'mobile') {
                this.fileList.push({
                  name: element.file_name,
                  status: 'success',
                  size: element.size,
                  type: '',
                });
              }
            } else if (element.origin == 'onboarding') {
              this.fileList.push({
                name: element.file_name,
                status: 'success',
                size: element.size,
                type: '',
              });
            }
          });
          this.completedCount = this.fileList.length;
          this.isLoading = false;
          this.cd.detectChanges();
        },
        (error: any) => {}
      )
    );
  }

  uploadDocument(element, name) {
    this.fileList.push({
      name: element.name,
      status: 'running',
      size: element.size,
      type: element.type,
    });
    const data = {
      user_id: this.loginStateObject.id,
      name: element.name,
      file_name_without_extesion: element.name.split('.').slice(0, -1).length == 0 ? element.name : element.name.split('.').slice(0, -1).join('.'),
      display_file_name: element.name,
      size: element.size,
      type: element.type,
      origin: this.origin,
    };
    this.CreteCreatePresignedUrl(data, element, this.fileList.length - 1);
  }
  async CreteCreatePresignedUrl(data, file, index) {
    return await new Promise(async (resolve) => {
      if (typeof Worker !== 'undefined') {
        const workerId = `presign-${Date.now()}-${Math.random()}`;
        const worker = new Worker(new URL('../../upload-presign-url.worker', import.meta.url), { type: 'module' });
        this.activeWorkers.set(workerId, worker);

        const session = await fetchAuthSession();
        const idToken = session.tokens?.idToken?.toString();

        const token = `Bearer ${idToken}`;
        data.token = token;
        data.url = `${environment.apiUrl}/api/vault/inbox-file-upload`;
        worker.onmessage = async ({ data }) => {
          //return security key generated by worker process
          resolve(data);
          let res = data.data;

          // Terminate and cleanup worker
          worker.terminate();
          this.activeWorkers.delete(workerId);

          if (res['uploadLimitExceeded']) {
            this.completedCount = this.completedCount + 1;
            this.fileList[index].status = 'fail';
            this.cd.detectChanges();
            return;
          } else if (res['limit_exceeded']) {
            this.fileList[index].status = 'fail';
            this.completedCount = this.completedCount + 1;
            this.cd.detectChanges();
            return;
          } else {
            this.saveFileAfterS3UrlCrete(res, file, res.id, index);
          }
        };
        worker.postMessage(data);
      } else {
        //browser does not support web-workers so just return a new data key, UI automation will be blocked
        resolve(this.generateCreatePresignedUrl(data));
      }
    });
  }
  async saveFileAfterS3UrlCrete(res, file, id, index) {
    let data = {
      file: file,
      token: null,
      url: null,
      fileType: null,
    };
    const xhr = new XMLHttpRequest();

    this.createFileAfterS3UrlCrete(data, res['upload_url'], file.type, file, id, index);
  }
  async createFileAfterS3UrlCrete(data, url, type, file, id, index) {
    return await new Promise(async (resolve) => {
      if (typeof Worker !== 'undefined') {
        const workerId = `s3-upload-${Date.now()}-${Math.random()}`;
        const worker = new Worker(new URL('../../upload-s3-image.worker', import.meta.url), { type: 'module' });
        this.activeWorkers.set(workerId, worker);

        const session = await fetchAuthSession();
        const idToken = session.tokens?.idToken?.toString();

        const token = `Bearer ${idToken}`;
        data.token = token;
        data.url = url;
        data.fileType = type;
        data.file = file;
        worker.onmessage = async ({ data }) => {
          //return security key generated by worker process
          resolve(data);

          // Terminate and cleanup worker
          worker.terminate();
          this.activeWorkers.delete(workerId);

          this.cd.detectChanges();

          this.updateFileStatus({ id: id }, index);
          this.cd.detectChanges();
        };
        worker.postMessage(data);
      } else {
        //browser does not support web-workers so just return a new data key, UI automation will be blocked
        resolve(this.generatecreateFileAfterS3UrlCrete(data));
      }
    });
  }
  async updateFileStatus(data, index) {
    return await new Promise(async (resolve) => {
      if (typeof Worker !== 'undefined') {
        const workerId = `status-update-${Date.now()}-${Math.random()}`;
        const worker = new Worker(new URL('../../upload-status-update.worker', import.meta.url), { type: 'module' });
        this.activeWorkers.set(workerId, worker);

        const session = await fetchAuthSession();
        const idToken = session.tokens?.idToken?.toString();

        const token = `Bearer ${idToken}`;
        data.token = token;
        data.url = `${environment.apiUrl}/api/vault/inbox-file-upload-status`;
        worker.onmessage = ({ data }) => {
          //return security key generated by worker process
          resolve(data);

          // Terminate and cleanup worker
          worker.terminate();
          this.activeWorkers.delete(workerId);

          this.fileList[index].status = 'success';
          this.completedCount = this.completedCount + 1;
          this.cd.detectChanges();
        };
        worker.postMessage(data);
      } else {
        //browser does not support web-workers so just return a new data key, UI automation will be blocked
        resolve(this.generateDataKeyPairFileStatus(data));
      }
    });
  }
  generateDataKeyPairFileStatus(security_key: any): unknown {
    throw new Error('Method not implemented.');
  }

  generatecreateFileAfterS3UrlCrete(data: any): unknown {
    throw new Error('Method not implemented.');
  }

  generateCreatePresignedUrl(security_key: any): unknown {
    throw new Error('Method not implemented.');
  }

  createrTreeStructureData(dataList, isUploadDedByFolder) {
    dataList.forEach(async (element) => {
      if (isUploadDedByFolder) {
        if (element.data.name == element.name) {
          this.cd.detectChanges();
          this.fileListDataTree.push(element);
        } else {
          this.createrTreeStructureData(element.children, isUploadDedByFolder);
        }
      } else {
        if (element.data.isFile) {
          this.cd.detectChanges();
          this.fileListDataTree.push(element);
        } else {
          this.createrTreeStructureData(element.children, isUploadDedByFolder);
        }
      }
    });
    this.showLader = false;
    this.cd.detectChanges();
  }

  submitForm() {
    this.moveNextPreviousEvent.next({ status: 'forward', id: this.data.id });
  }
  dropleave(ev) {}

  allowDrop(ev) {
    ev.preventDefault();
  }

  drop(ev) {}
  onFileChanged(event, type) {
    this.uploadFile(event);
  }
  uploadFile(event) {
    const items = event.target.files;
    Object.keys(items).forEach((key, index) => {
      this.uploadDocument(items[key], items[key]?.name);
    });
    this.cd.markForCheck();
  }

  myFunction(event) {
    this.isActiveDrag = false;
    this.cd.detectChanges();
  }

  onDragStart(event) {
    this.isActiveDrag = true;
    this.cd.detectChanges();
  }
  onDrag(event) {
    this.isActiveDrag = true;
    this.cd.detectChanges();
  }
  onDragEnd(event) {
    this.isActiveDrag = false;
    this.cd.detectChanges();
  }
  async dragged(event) {
    this.isActiveDrag = false;
    this.folderList = [];
    const items = event.dataTransfer.items;
    const fileLists = event.dataTransfer.files;
    this.data = {
      items,
      fileLists,
      folderList: this.folderList,
    };
    this.cd.detectChanges();
    for (let i = 0; i < items.length; i++) {
      let item = items[i].webkitGetAsEntry();
      let fileList = fileLists[i];
      item.size = fileList.size;
      item.type = fileList.type;
      item.completed = false;
      if (item) {
        this.scanAndLogFiles(item);
      }
    }
  }
  async scanAndLogFiles(item) {
    // const newFile = item.event.dataTransfer.files;
    let newElt = item;

    if (item.isDirectory) {
      const promise = [];
      let directoryReader = item.createReader();
      directoryReader.readEntries((entries) => {
        entries.forEach(async (entry) => {
          try {
            // this.readFile(entry, null, null)
          } catch (error) {}

          this.scanAndLogFiles(entry);
        });
      });
    }

    if (item.isDirectory) {
      newElt.originalFile = undefined;
      this.data.folderList.push(newElt);
    } else {
      item.file((file) => {
        this.uploadDocument(file, file.name);
      });
    }
  }
  backForm() {
    this.moveNextPreviousEvent.next({ status: 'backward' });
  }
}
